// This is the current way we initialise our custom modules
// All modules should have an entry point that is called from here, to ensure that browser shims have loaded when they are executed

import './MegaModal';
import './Toggle';
import './lazyImages';
import './validate';
import './formAutocompleter';
import './showHide';
import './progressButton';
import './cookieBanner';
import './ratingStarDescriptors';
import './caribouModalNudgeMessage';
import './analytics';
import * as slider from './slider';
import NavGlobal from './navGlobal';
import AddressLookupController from './AddressLookupController';
import itemSelector from './itemSelector';
import landingModalMessage from './landingModalMessage';
import AllergenInteractionModalMessage from './allergenInteractionModalMessage';
import ageVerification from './ageVerification';

// Experiments
import '../experiments/IWEB-4523/specificLocationRequired';

var Modules = {
    // called by our index.js when shims have loaded
    init: function () {

        //initialise our custom modules
        Modules._moduleInitialiser();

    },

    // Can either initialise here via an init function, or (best way) to make your module self executing on load
    _moduleInitialiser: function () {
        landingModalMessage.init();
        NavGlobal.init();
        AddressLookupController.init();
        itemSelector.init();
        slider.init();
        AllergenInteractionModalMessage.init('[data-allergen-feature-toggle]');
        ageVerification.init();
    }
};

export default Modules.init;
